import apiHelpers from '@/utils/api'
import { AlrContainer } from '@/models/response/AlrContainer'
import { AxiosPromise } from 'axios'
import { AloNewsletter,cleanAloNewsletter } from '@/models/alo/AloNewsletter'

export default {
  getAllNewsletter(): AxiosPromise<AlrContainer<Array<AloNewsletter>>> {    
    return apiHelpers.apiCall({ 
      url: `/webapi/Newsletter`, 
      method: 'GET',
      transformResponse: [function (data:string) {          
        return JSON.parse(data) as AlrContainer<Array<AloNewsletter>>
      }]
    })
  },
  getNewsletter(id:number):AxiosPromise<AlrContainer<AloNewsletter>> {
    return  apiHelpers.apiCall({ 
      url: `/webapi/Newsletter/${id}`, 
      method: 'GET',
      transformResponse: [function (data:string) {          
        return JSON.parse(data) as AlrContainer<AloNewsletter>
      }]
    })
  },
  saveNewsletter(newsletter:AloNewsletter):AxiosPromise<AlrContainer<AloNewsletter>> {
    cleanAloNewsletter(newsletter)
    if(newsletter.id) {
      return  apiHelpers.apiCall({ 
        url: `/webapi/Newsletter/${newsletter.id}`, 
        method: 'PUT',
        data: newsletter,
        transformResponse: [function (data:string) {          
          return JSON.parse(data) as AlrContainer<AloNewsletter>
        }]
      })    
    }
    else{
      return  apiHelpers.apiCall({ 
        url: `/webapi/Newsletter`, 
        method: 'POST',
        data: newsletter,
        transformResponse: [function (data:string) {          
          return JSON.parse(data) as AlrContainer<AloNewsletter>
        }]
      })    
    }
  },
  deleteNewsletter(id:number):AxiosPromise<AlrContainer<AloNewsletter>>{
    return  apiHelpers.apiCall({ 
      url: `/webapi/Newsletter/${id}`, 
      method: 'DELETE',
      transformResponse: [function (data:string) {          
        return JSON.parse(data) as AlrContainer<AloNewsletter>
      }]
    })
  },
  validNewsletter(key:string):AxiosPromise<AlrContainer<AloNewsletter>>{
    return  apiHelpers.apiCall({ 
      url: `/webapi/Newsletter/valid`, 
      method: 'GET',      
      params:{key},
      transformResponse: [function (data:string) {          
        return JSON.parse(data) as AlrContainer<AloNewsletter>
      }]
    })
  },
  executeActionOnSelection(payload:{conIds:Array<number>,action:string,data?:any}){
    return  apiHelpers.apiCall({ 
      url: `/webapi/Newsletter/execute`,
      method: 'PUT',
      data:payload,
      transformResponse: [function (data:string) {          
        return JSON.parse(data) as AlrContainer<Array<AloNewsletter>>
      }]
    })    
  }
}